export default __webpack_public_path__ + "static/media/best_website.38f24c86.png";